import { Directive, booleanAttribute, input } from '@angular/core';

/**
 * Étiquette de prix « à la craie » — la signature visuelle du produit.
 *
 * Elle rappelle l'ardoise de l'étal de marché et distingue Champ'Table d'une
 * marketplace générique. Elle est donc réservée au prix et au chiffre
 * d'affaires : l'employer pour un libellé ordinaire lui ferait perdre son
 * effet.
 *
 * La rotation est décorative. Elle est appliquée par une transformation CSS et
 * non par une police inclinée, pour que le texte reste sélectionnable et lisible
 * par les technologies d'assistance.
 */
@Directive({
  selector: '[ctChalkTag]',
  host: {
    class: 'ct-chalk',
    '[class.ct-chalk--small]': 'small()',
  },
})
export class CtChalkTag {
  /** Variante compacte, pour un tableau de bord plutôt qu'une fiche produit. */
  readonly small = input(false, { transform: booleanAttribute });
}
